import { Injectable } from '@angular/core';
import { JsonService }  from '../../services/json/json.service';
import { Http } from '@angular/http';

@Injectable()
export class GridService extends JsonService {
  constructor(public http: Http) {
    super(http);
  }
}
